export const autoria = {
  meusCursos: {
    title: 'My Courses',
    description: 'Create and manage the courses you author.',
    novoCurso: 'New course',
    empty: 'You haven’t created any courses yet.',
    emptyDescription: 'Create your first course to build modules, lessons, and quizzes.',
    abrir: 'Open editor',
    acoes: 'Actions',
    excluirTitle: 'Remove course?',
    excluirDescription: 'This action cannot be undone.',
  },
  novoCurso: {
    title: 'New course',
    titulo: 'Title',
    tituloPlaceholder: 'e.g., Clean Architecture in practice',
    descricao: 'Description',
    descricaoPlaceholder: 'Summary of what the course covers (optional)',
    emiteCert: 'Issues certificate',
    emiteCertHint: 'This option locks after the first publication.',
    criar: 'Create course',
  },
  editor: {
    voltar: 'My Courses',
    metadados: 'Course metadata',
    estrutura: 'Structure',
    semModulos: 'No modules yet.',
    semAulas: 'No lessons',
    novoModulo: 'New module',
    novaAula: 'New lesson',
    selecioneAula: 'Select a lesson to edit its content.',
    emiteCertCongelado: 'Locked after publication.',
    moverAcima: 'Move up',
    moverAbaixo: 'Move down',
    renomear: 'Rename',
    acoes: 'Actions',
  },
  modulo: {
    novoTitulo: 'Module title',
    excluirTitle: 'Delete module?',
    excluirDescription: 'This removes the module and all its lessons. It cannot be undone.',
  },
  aula: {
    novoTitulo: 'Lesson title',
    tipo: 'Type',
    opcional: 'Optional (does not count toward completion)',
    kind: {
      text: 'Text',
      video: 'Video',
      quiz: 'Quiz',
    },
    excluirTitle: 'Delete lesson?',
    excluirDescription: 'The lesson and its content will be removed. It cannot be undone.',
  },
  aulaEditor: {
    title: 'Edit lesson',
    titulo: 'Title',
    conteudo: 'Lesson content',
    video: {
      provider: 'Provider',
      externalRef: 'Video ID',
      externalRefHint: 'The video’s identifier on the provider (e.g., dQw4w9WgXcQ).',
      preview: 'Preview',
      semPreview: 'Enter the provider and video ID to see the preview.',
    },
    quiz: {
      intro: 'Edit the question bank and parameters for this quiz.',
    },
  },
  quiz: {
    title: 'Quiz editor',
    naoConfigurado: 'Quiz not set up yet',
    naoConfiguradoHint: 'Create the quiz to define its parameters and add questions.',
    configurar: 'Set up quiz',
    parametros: 'Parameters',
    notaMinima: 'Minimum passing score (%)',
    tentativas: 'Attempts',
    ilimitadas: 'Unlimited',
    maximo: 'Maximum',
    salvarParametros: 'Save parameters',
    banco: 'Question bank',
    novaQuestao: 'New question',
    semQuestoes: 'No questions yet.',
    semQuestoesHint: 'Add at least 1 question to publish this quiz lesson.',
    enunciado: 'Prompt',
    enunciadoPlaceholder: 'Type the question prompt',
    tipoSingle: 'Multiple choice',
    tipoTf: 'True / False',
    opcao: 'Option',
    opcaoPlaceholder: 'Option text',
    addOpcao: 'Add option',
    correta: 'Correct',
    verdadeiro: 'True',
    falso: 'False',
    correctIsTrue: 'Correct answer',
    salvarQuestao: 'Save question',
    excluirQuestaoTitle: 'Remove question?',
    excluirQuestaoDescription: 'The question and its options will be removed. It cannot be undone.',
    erroSingleUmaCorreta: 'Multiple choice requires exactly one correct option.',
    erroSingleMinOpcoes: 'Multiple choice requires at least two options.',
    erroEnunciadoVazio: 'The prompt cannot be empty.',
    erroOpcaoVazia: 'Option text cannot be empty.',
  },
  videoAula: {
    origem: 'Video source',
    origemArquivo: 'Upload a file',
    origemLink: 'YouTube/Vimeo link',
    aguardando: 'Waiting for video',
    novaAulaDica:
      'The lesson starts waiting for a video and stays coming soon until you upload the video and release it.',
    soltarArquivo: 'Drag the MP4 video here or click to choose',
    soltarDescricao: 'MP4 file up to 1 GB.',
    escolherArquivo: 'Choose file',
    enviando: 'Uploading: {{percent}}%',
    confirmando: 'Checking the file...',
    pausado: 'Upload paused at {{percent}}%.',
    cancelar: 'Cancel upload',
    retomar: 'Resume upload',
    descartar: 'Choose another file',
    trocar: 'Replace video',
    remover: 'Remove video',
    removerTitulo: 'Remove the video?',
    removerDescricao:
      'The file is deleted and the lesson goes back to coming soon until it gets another video.',
    atual: 'Current video: {{nome}} ({{tamanho}})',
    enviado: 'Video uploaded.',
    removido: 'Video removed.',
    salvarLink: 'Save link',
    trocarParaLinkTitulo: 'Replace the file with the link?',
    trocarParaLinkDescricao: 'The uploaded video and its caption will be deleted.',
    legenda: 'Caption (.vtt)',
    legendaDica: 'Optional. UTF-8 WebVTT file, up to 512 KB.',
    legendaSemVideo: 'Upload the video before the caption.',
    legendaEnviar: 'Upload caption',
    legendaTrocar: 'Replace caption',
    legendaRemover: 'Remove caption',
    legendaAtual: 'Caption uploaded.',
    legendaEnviada: 'Caption saved.',
    legendaRemovida: 'Caption removed.',
    previa: 'Preview',
    previaIndisponivel: 'The preview appears after the video is uploaded.',
    playerRotulo: 'Lesson video',
    legendaPt: 'Portuguese (Brazil)',
    playerFalhou: 'The video could not be loaded.',
    tentarDeNovo: 'Try again',
    erros: {
      formato: 'Upload an MP4 file.',
      tamanho: 'The video exceeds the 1 GB limit.',
      rede: 'The connection dropped during the upload. Use “Resume upload” to continue where it stopped.',
      expirado: 'The upload link expired. Use “Resume upload” to continue.',
      incompleto: 'The file arrived incomplete. Please upload it again.',
      indisponivel: 'Video upload is not available in this environment yet.',
      cancelado: 'Upload canceled.',
      legenda: 'The caption must be a UTF-8 .vtt file up to 512 KB.',
      generico: 'The video could not be uploaded. Please try again.',
    },
  },
  liberacao: {
    rotulo: 'Availability for students',
    liberada: 'Released',
    emBreve: 'Coming soon',
    precisaVideo: 'Upload the video or add a link before releasing this lesson.',
    alterada: 'Availability updated.',
    avisoCurso_one: '{{count}} lesson is coming soon and does not open for students yet.',
    avisoCurso_other: '{{count}} lessons are coming soon and do not open for students yet.',
  },
  toast: {
    cursoCriado: 'Course created.',
    cursoAtualizado: 'Course updated.',
    cursoExcluido: 'Course removed.',
    cursoPublicado: 'Course published.',
    cursoArquivado: 'Course archived.',
    moduloCriado: 'Module created.',
    moduloAtualizado: 'Module updated.',
    moduloExcluido: 'Module removed.',
    aulaCriada: 'Lesson created.',
    aulaAtualizada: 'Lesson saved.',
    aulaExcluida: 'Lesson removed.',
    ordemAtualizada: 'Order updated.',
    quizCriado: 'Quiz created.',
    parametrosSalvos: 'Parameters saved.',
    questaoAdicionada: 'Question added.',
    questaoAtualizada: 'Question updated.',
    questaoRemovida: 'Question removed.',
  },
  erros: {
    cursoEmUso:
      'Could not remove: there are enrollments or use in a track. Archive instead of removing.',
    emiteCertCongelado: 'The certificate was locked at publication and cannot be changed.',
    kindNaoQuiz: 'This lesson is not a quiz.',
  },
} as const;
